export default __webpack_public_path__ + "static/media/rayon.fc069cb1.webp";